module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-03.1ae733b4.jpg";